import { createRouter, createWebHistory } from 'vue-router';
import { blogIndex } from '../content/index.js';
// Import your view components
import HomePage from "../components/HomePage"
import AboutMe from "../components/AboutMe"
import NewsletterPage from "../components/NewsletterPage.vue"
import ResourcesPage from "../components/ResourcesPage.vue"

// 1. Rename your "BlogPost" to "BlogPage" (the list)
// 2. Import your new "BlogPostDetail" (the template)
import BlogPost from "../components/BlogPost.vue"
import BlogPageDetail from "../components/BlogPageDetail.vue"

function setMeta({ title, description, url }) {
    document.title = title;
    const set = (sel, attr, val) => {
        const el = document.querySelector(sel);
        if (el) el.setAttribute(attr, val);
    };
    set('meta[property="og:title"]',       'content', title);
    set('meta[property="og:description"]', 'content', description);
    set('meta[property="og:url"]',          'content', url);
    set('meta[name="twitter:title"]',       'content', title);
    set('meta[name="twitter:description"]', 'content', description);
    set('meta[name="description"]',         'content', description);
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/blog/:id', // The Detail Page (Template)
    name: 'BlogPageDetail',
    component: BlogPageDetail
  },
  {
    path: '/blog', // The List Page
    name: 'Blog',
    component: BlogPost
  },
  {
    path: '/about',
    name: 'About',
    component: AboutMe
  },
  {
    path: '/newsletter',
    name: 'Newsletter',
    component: NewsletterPage
  },
  {
    path: '/resources',
    name: 'Resources',
    component: ResourcesPage
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});
// Update meta tags and track page views
router.afterEach((to) => {
    const baseUrl = window.location.origin;
    const pageUrl = baseUrl + to.fullPath;

    if (to.name === 'BlogPageDetail' && to.params.id) {
        const post = blogIndex.find(p => p.id === to.params.id);
        if (post) {
            setMeta({
                title: `${post.title} | Aisha's Tech Room`,
                description: post.excerpt,
                url: pageUrl,
            });
        }
    } else if (to.name === 'Blog') {
        setMeta({
            title: 'Blog | Aisha\'s Tech Room',
            description: 'Tech career advice, software development tips, and personal growth stories from Aisha\'s Tech Room.',
            url: pageUrl,
        });
    } else if (to.name === 'About') {
        setMeta({
            title: 'About | Aisha\'s Tech Room',
            description: 'Learn more about Aisha\'s Tech Room — technical writer and software developer.',
            url: pageUrl,
        });
    } else if (to.name === 'Newsletter') {
      setMeta({
        title: 'Newsletter | Aisha\'s Tech Room',
        description: 'Subscribe to weekly tech career insights, remote jobs, and practical tips for navigating a tech career abroad.',
        url: pageUrl
      });
    } else if (to.name === 'Resources') {
      setMeta({
        title: 'Free AI Resources for People Breaking Into Tech | Tech Education',
        description: 'Free AI resources for people breaking into tech. Access the PDF guide through signup.',
        url: pageUrl
      });
    } else {
        setMeta({
            title: 'Aisha\'s Tech Room | Frontend Developer & Developer Experience',
            description: 'Real-life advice on navigating and working in the tech industry.',
            url: pageUrl
        });
    }

    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-2FT9QFB45P', {
        page_path: to.fullPath,
        page_title: to.name || document.title,
      });
    }
  });
export default router;
